export enum CampaignTypes {
  Traditional = 1,
  Integration = 2,
  Facebook = 3
}
